<template>
  <v-container fluid class="pa-6">
    <v-row justify="center">
      <v-col cols="12" md="8" lg="6">
        <v-card 
          class="pa-8 text-center" 
          outlined
          style="border-radius: 4px; border: 1px solid #e0e0e0; max-width: 650px; margin: 0 auto;"
        >
          <h2 class="text-h5 font-weight-medium mb-3" style="color: #005f32;">Upload Career Graph Data</h2>
          <p class="text-body-1 mb-6" style="color: #666; max-width: 500px; margin: 0 auto; line-height: 1.6;">
            Upload the Excel file (.xlsx) containing employee career graph data to bulk import or update records.
          </p>
          
          <v-file-input
            v-model="file"
            accept=".xlsx, .xls"
            label="Select Excel File"
            prepend-icon="mdi-file-excel-box"
            color="#005f32"
            outlined
            show-size
            class="mb-6 custom-file-input"
          ></v-file-input>

          <v-btn 
            color="#005f32" 
            outlined
            @click="uploadFile" 
            :loading="loading" 
            :disabled="!file || loading"
            class="px-6 mb-2 font-weight-bold"
          >
            <v-icon left>mdi-upload</v-icon>
            UPLOAD DATA
          </v-btn>

          <v-alert v-if="successMsg" type="success" class="mt-6 text-left" dismissible>
            {{ successMsg }}
            <div v-if="summary" class="mt-2 text-body-2">
              <strong>Processed:</strong> {{ summary.Processed }} <br/>
              <strong>Created:</strong> {{ summary.Created }} <br/>
              <strong>Updated:</strong> {{ summary.Updated }} <br/>
              <strong>Failed:</strong> {{ summary.Failed }}
            </div>
          </v-alert>

          <v-alert v-if="errorMsg" type="error" class="mt-6 text-left" dismissible>
            {{ errorMsg }}
          </v-alert>

          <v-expansion-panels v-if="summary && summary.Errors && summary.Errors.length > 0" class="mt-4 text-left">
            <v-expansion-panel>
              <v-expansion-panel-header class="red--text font-weight-bold">View Row Errors ({{ summary.Errors.length }})</v-expansion-panel-header>
              <v-expansion-panel-content>
                <ul class="text-caption red--text">
                  <li v-for="(err, i) in summary.Errors" :key="i">{{ err }}</li>
                </ul>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CareerGraphUpload',
  data() {
    return {
      file: null,
      loading: false,
      successMsg: '',
      errorMsg: '',
      summary: null
    };
  },
  methods: {
    async uploadFile() {
      if (!this.file) return;
      
      this.loading = true;
      this.successMsg = '';
      this.errorMsg = '';
      this.summary = null;

      let formData = new FormData();
      formData.append('file', this.file);

      try {
        const token = localStorage.getItem('token');
        const res = await axios.post('/career-graph/upload', formData, {
          headers: {
            'x-auth-token': token,
            'Content-Type': 'multipart/form-data'
          }
        });

        if (res.data.status) {
          this.successMsg = res.data.msg || 'Upload processed successfully!';
          this.summary = res.data.summary;
          this.file = null;
        } else {
          this.errorMsg = res.data.msg || 'Failed to process the file.';
        }
      } catch (err) {
        console.error(err);
        this.errorMsg = err.response && err.response.data && err.response.data.msg 
            ? err.response.data.msg 
            : 'An error occurred while uploading the file.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
::v-deep .custom-file-input .v-input__slot fieldset {
  border-color: #005f32 !important;
}
::v-deep .custom-file-input:hover .v-input__slot fieldset {
  border-color: #005f32 !important;
  border-width: 2px !important;
}
::v-deep .custom-file-input .v-icon {
  color: #005f32 !important;
}
</style>
